module.exports = __webpack_public_path__ + "img/icon_map_ymbz_c.a906eae2.png";